import { Mask } from '@/types';
import { dynamicMask } from './dynamic-mask';
import { maskit } from './maskit';

export const masker = (value: string, mask: Mask, masked = true): string =>
  Array.isArray(mask) ? dynamicMask(mask, masked)(value) : maskit(value, mask, masked);
